export function formatBytes(bytes) {
  if (!bytes || bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

export function formatTime(seconds) {
  if (!seconds || seconds <= 0) return '--';
  if (seconds < 60) return `${seconds}s`;
  if (seconds < 3600) {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return s > 0 ? `${m}m ${s}s` : `${m}m`;
  }
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  return m > 0 ? `${h}h ${m}m` : `${h}h`;
}

export function formatDuration(startDate, endDate) {
  if (!startDate) return '--';
  const start = new Date(startDate).getTime();
  const end = endDate ? new Date(endDate).getTime() : Date.now();
  return formatTime(Math.round((end - start) / 1000));
}

export function getSourceName(sourceId) {
  const names = {
    CPANEL: 'cPanel',
    TITAN: 'Titan Mail',
    MS_EXCHANGE: 'Microsoft 365',
    GSUITE: 'Google Workspace',
    YAHOO: 'Yahoo Mail',
    ZOHO: 'Zoho Mail',
    IMAP: 'Generic IMAP'
  };
  return names[sourceId] || sourceId;
}

export function getSourceIcon(sourceId) {
  const icons = {
    CPANEL: '/migration/CPanel.webp',
    TITAN: '/migration/titan.webp',
    MS_EXCHANGE: '/migration/Microsoft_Exchang.webp',
    GSUITE: '/migration/Gmail.webp',
    YAHOO: '/migration/Yahoo!_Mail.svg',
    ZOHO: '/migration/Zoho_Mail.webp'
  };
  return icons[sourceId] || null;
}

export function parseCSV(text) {
  const lines = text.trim().split('\n');
  if (lines.length < 2) return { headers: [], rows: [], errors: ['CSV must have at least a header row and one data row'] };

  const headers = lines[0].split(',').map(h => h.trim().toLowerCase());
  const rows = [];
  const errors = [];

  for (let i = 1; i < lines.length; i++) {
    const values = lines[i].split(',').map(v => v.trim());
    if (values.length !== headers.length) {
      errors.push(`Row ${i + 1}: Expected ${headers.length} columns, got ${values.length}`);
      continue;
    }

    const row = {};
    headers.forEach((h, idx) => {
      row[h] = values[idx];
    });

    // Validate required fields
    if (!row.email) {
      errors.push(`Row ${i + 1}: Missing email`);
    }
    if (!row.password) {
      errors.push(`Row ${i + 1}: Missing password`);
    }

    row._rowNumber = i + 1;
    row._valid = !!(row.email && row.password);
    rows.push(row);
  }

  return { headers, rows, errors };
}
